"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

var _svgIcons = require("../internal/svg-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ENTER_KEY = 13;
var SPACEBAR_KEY = 32;

var ExpansionPanel = function ExpansionPanel(_ref) {
  var CaretIcon = _ref.caretIcon,
      className = _ref.className,
      details = _ref.details,
      disabled = _ref.disabled,
      expandedProp = _ref.expanded,
      header = _ref.header,
      icon = _ref.icon,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      panelDetailClassName = _ref.panelDetailClassName,
      panelHeaderClassName = _ref.panelHeaderClassName,
      tabIndex = _ref.tabIndex,
      togglePanel = _ref.togglePanel,
      restOfProps = _objectWithoutProperties(_ref, ["caretIcon", "className", "details", "disabled", "expanded", "header", "icon", "onClick", "onKeyDown", "panelDetailClassName", "panelHeaderClassName", "tabIndex", "togglePanel"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setExpanded = _useState2[1];
  /**
   * Computes the true visibility state of the panel
   * If an expandedProp is passed down, we should use that over local state
   */


  var getExpandedStatus = function getExpandedStatus() {
    var status = isExpanded;

    if (expandedProp !== null) {
      status = expandedProp;
    }

    return status;
  };

  var expanded = getExpandedStatus();

  var handleExpansion = function handleExpansion(e, handler) {
    /**
     * Controlled handler: this will send props back to parent controller
     * to handle the visibility state
     */
    if (typeof togglePanel === 'function') {
      togglePanel(e, expandedProp);
    }

    setExpanded(!expanded);

    if (typeof handler === 'function') {
      handler(e);
    }
  };

  var enabledProps = {};

  if (!disabled) {
    enabledProps.onClick = function (e) {
      handleExpansion(e, onClick);
    };

    enabledProps.onKeyDown = function (e) {
      var validKeyPress = e.keyCode === SPACEBAR_KEY || e.keyCode === ENTER_KEY;

      if (validKeyPress) {
        handleExpansion(e, onKeyDown);
      } else if (typeof onKeyDown === 'function') {
        onKeyDown(e);
      }
    };
  }

  var computedTabIndex = tabIndex;
  /**
   * A user should be able to skip over a disabled panel
   * However, enable a user to pass tabIndex and NOT skip if they choose to do so
   */

  if (disabled) {
    computedTabIndex = tabIndex > 0 ? tabIndex : -1;
  }

  var panelClasses = (0, _classnames.default)(className, {
    'pds-expansion-panel': true,
    'pds-expansion-panel--disabled': disabled
  });
  var panelDetailClasses = (0, _classnames.default)(panelDetailClassName, {
    'pds-expansion-panel__details': true,
    'pds-expansion-panel__details--active': expanded
  });
  var panelCaretClasses = (0, _classnames.default)({
    'pds-expansion-panel__caret': !expanded,
    'pds-expansion-panel__caret--inverted': expanded
  });
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", _extends({}, restOfProps, enabledProps, {
    className: panelClasses,
    disabled: disabled,
    role: "button",
    tabIndex: computedTabIndex
  }), _react.default.createElement("div", {
    className: "pds-expansion-panel__section"
  }, icon && _react.default.createElement("span", {
    className: "pds-expansion-panel__icon-wrapper"
  }, icon), _react.default.createElement("div", {
    className: (0, _classnames.default)(panelHeaderClassName, 'pds-expansion-panel__header')
  }, header)), _react.default.createElement("span", {
    className: panelCaretClasses
  }, _react.default.createElement(CaretIcon, {
    disabled: disabled
  }))), _react.default.createElement("div", {
    className: panelDetailClasses
  }, details));
};

ExpansionPanel.propTypes = {
  /**
   * Icon to be displayed to the right of the ExpansionPanel.
   */
  caretIcon: _propTypes.func,

  /**
   * Applies additional CSS classes to the wrapper element of the panel
   * header section.
   */
  className: _propTypes.string,

  /**
   * Content to be rendered when the ExpansionPanel is in an expanded state.
   */
  details: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]).isRequired,

  /**
   * Whether or not the component can be interacted with or focused on.
   */
  disabled: _propTypes.bool,

  /**
   * If a boolean value is defined, this (parent level prop) will be used to
   * determine the expansion state for the panel instead of local state.
   */
  expanded: _propTypes.bool,

  /**
   * Header/section content to be displayed; this is visible at all times,
   * regardless of expanded state.
   */
  header: _propTypes.string.isRequired,

  /**
   * Additional icon to be displayed to the left of the panel header.
   */
  icon: _propTypes.node,

  /**
   * Unique identifier for accessibility purposes.
   */
  id: _propTypes.string.isRequired,

  /**
   * Additional click handler to be applied on the wrapper element; the
   * ExpansionPanel click handler will manage the state to expand/contract
   * the contents.
   */
  onClick: _propTypes.func,

  /**
   * Additional keydown handler to be applied on the wrapper element; the
   * ExpansionPanel onKeyDown handler uses the space and enter key to manage
   * the state for expanding/contracting the contents.
   */
  onKeyDown: _propTypes.func,

  /**
   * Applies additional CSS classes to the panel content element.
   */
  panelDetailClassName: _propTypes.string,

  /**
   * Applies additional CSS classes to the panel header element.
   */
  panelHeaderClassName: _propTypes.string,

  /**
   * Overrides the existing tabIndex; useful for allowing the panels to be
   * focused/tabbed to in a disabled state.
   */
  tabIndex: _propTypes.number,

  /**
   * If a function is provided, this will be invoked when the panel is
   * expanded/contracted, passing the event object and the parent provided
   * `expanded` prop as arguments; primarily used as a mechanism to control
   * the `ExpansionPanel` expanded state at the parent level.
   */
  togglePanel: _propTypes.func
};
ExpansionPanel.defaultProps = {
  caretIcon: _svgIcons.CaretDown,
  className: null,
  disabled: false,
  expanded: null,
  icon: null,
  onClick: null,
  onKeyDown: null,
  panelDetailClassName: null,
  panelHeaderClassName: null,
  tabIndex: 0,
  togglePanel: null
};
var _default = ExpansionPanel;
exports.default = _default;
